// PAVIRA theme interactions
document.addEventListener('DOMContentLoaded', function () {

  /* Scroll reveal */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Wishlist toggle (local, visual only) */
  document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.classList.toggle('active');
    });
  });

  /* Mobile nav */
  var burger = document.querySelector('.header-burger');
  var mobileNav = document.querySelector('.mobile-nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      document.body.classList.toggle('nav-open');
    });
  }

  /* Product gallery thumbs */
  document.querySelectorAll('.product-gallery__thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.product-gallery__main img');
      if (!main) return;
      document.querySelectorAll('.product-gallery__thumbs img').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      main.src = thumb.dataset.full || thumb.src;
    });
  });

  /* Quantity selector */
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var input = sel.querySelector('input');
    sel.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        val = btn.dataset.action === 'increase' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
        var stickyQty = document.querySelector('[data-sticky-qty]');
        if (stickyQty) stickyQty.value = val;
        var mainQty = document.querySelector('[data-main-qty]');
        if (mainQty && mainQty !== input) mainQty.value = val;
      });
    });
  });

  /* Sticky Add to Cart visibility */
  var mainForm = document.querySelector('[data-main-product-form]');
  var stickyBar = document.querySelector('.sticky-atc');
  if (mainForm && stickyBar) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.style.display = entry.isIntersecting ? 'none' : 'flex';
      });
    }, { threshold: 0 });
    observer.observe(mainForm);
  }

  /* Sticky ATC triggers main Add to Cart */
  var stickyAtcBtn = document.querySelector('[data-sticky-atc-btn]');
  if (stickyAtcBtn && mainForm) {
    stickyAtcBtn.addEventListener('click', function () {
      var submitBtn = mainForm.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.click();
    });
  }

  /* Announcement bar / cart count is handled by Shopify cart AJAX API on real store */
});
